module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "protocol"
  }, [_c('div', {
    staticClass: "main",
    staticStyle: {
      "padding": "0 6% 15px 6%"
    }
  }, [_c('p', {
    staticClass: "title",
    staticStyle: {
      "text-align": "center",
      "margin-top": "10px",
      "margin-bottom": "3px",
      "background": "rgba(255,255,255,0)"
    }
  }, [_vm._v("WiFi万能钥匙商户热点安全保险协议")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本协议为WiFi万能钥匙商户用户（即同意并接受了《WiFi万能钥匙服务协议》及《WiFi万能钥匙隐私权政策》的商户用户，以下简称“商户”）与南京尚网网络科技有限公司（以下简称“WiFi万能钥匙”或“本公司”）关于WiFi万能钥匙安全保险事宜所订立的协议。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("——本公司在此依法做出特别提示如下：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1、"), _c('b', [_vm._v("【审慎阅读】请您务必审慎阅读、充分理解各条款内容，特别是免除或者限制责任的条款、法律适用和争议解决条款。")]), _vm._v(" 针对前述条款，本协议已以明确的足以引起您注意的包括但不限于加重字体、斜体、下划线、颜色标记等合理方式提醒您注意相关条款（需要强调的是，还包括您应特别注意任何未明确标记的含有“不承担”、“免责”、“不得”以及“无关”等形式用语的条款），该等条款的确认将导致您在特定情况下的被动、不便和/或造成损失，请您在确认同意本协议之前再次阅读上述条款。 除非您已审慎阅读、充分理解并同意本协议所有条款，您将放弃参加本保险计划。 ")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2、"), _c('b', [_vm._v("本协议签署后，您如有任何需要本公司说明条款的要求，请立即停止参加本保险计划，同时立即致电或发送邮件至本公司客服，若您未致电或未发送有说明条款要求的邮件至本公司，即表示您选择同意该协议的所有条款。")]), _vm._v(" 双方在此确认本公司已依法履行了根据您要求对相关条款进行说明的法定义务，本公司已给予您充足的时间与充分的选择权来决定是否缔结本协议。 ")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3、"), _c('b', [_vm._v("【协议的确认和接受】鉴于本公司已依法明确了上述条款，您点击“同意”或“下一步”，将被视为且应当被视为您已经完全注意并“同意”了本协议所有条款尤其是提醒您注意的条款的合法性及有效性，您不应当以本公司未对相关条款以合理方式提醒您注意，或未根据您要求尽到说明义务为理由而声称或要求法院或其它任何第三方确认相关条款非法或无效。 如果您不同意本协议的任何内容，点击“不同意”，视为您选择放弃参加本保险计划。")])]), _vm._v(" "), _c('p', [_vm._v("4、【协议的修改】 本协议可由本公司适时更新，更新后的协议条款一经公布即替代原协议条款，您可在软件客户端查阅最新版协议。 "), _c('b', [_vm._v("在本公司修改协议并公布后，如果您不接受修改后的协议，请立即停止参加本保险计划，您一旦发起索赔申请将被视为已接受修改后的协议。")])]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("一、协议总则")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("WiFi万能钥匙热点商户联盟安全理赔计划（亦简称“本保险计划”）是指商户通过WiFi万能钥匙分享WiFi热点（以下亦简称“热点”）后，因发生黑客篡改WiFi密码、劫持商户收银、盗刷商户账户内资金等恶意行为导致商户产生损失的，商户可以依据本协议的有关规则申请理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("本公司已通过众安在线财产保险股份有限公司（以下简称“保险公司”）为WiFi万能钥匙的安全性进行投保。WiFi万能钥匙商户安全保险计划（以下简称“保险计划”）旨在为商户营造一个安全、可信的网络环境，让商户更放心地提供WiFi热点分享。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("二、定义")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("在本协议中，除非另有明确约定，提及的词语应具有如下含义：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("WiFi热点：本协议中所述WiFi热点特指通过WLAN无线协议将网络连接进行延伸的无线接入点,有连接网络需求的用户（以下称为“用户”）可通过WiFi万能钥匙进行相应操作实现网络连接并上网；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("有钥匙热点：商户通过WiFi万能钥匙客户端或其他渠道已向本公司分享的WiFi热点，商户的WiFi热点信息将会以有钥匙热点（用户通过点击WiFi万能钥匙客户端中的“一键查询”功能或下拉连接页面发起“一键查询”功能，成功查询附近热点后，在热点上有蓝色钥匙标识的热点）的形式呈现在进入该热点覆盖范围的用户设备的网络信息中；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("钓鱼网站：指不法分子在互联网上建立的通过模仿合法、正规购物平台的网址或页面内容，利用发布虚假消息，搜集客户资料，骗取客户账户（登录ID）、密码、口令等信息进而达到非法窃取客户财物的目的非法网站；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("木马病毒：指不法分子通过各种网络技术手段来篡改商户交易信息或者劫持商户收银系统等方式来达到盗取商户资金目的的恶意程序；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("勒索病毒：是一种新型计算机病毒，主要以邮件、程序木马、网页挂马的形式进行传播。这种病毒利用各种加密算法对文件进行加密，被感染者一般无法解密，必须交付赎金，拿到解密的私钥才有可能破解；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("恶意软件：\"恶意软件\"用作一个集合名词，来指代故意在计算机系统恶意软件上执行恶意任务的蠕虫、木马病毒或其他病毒；在恶意软件未被发现的这段时间，商户上网过程中的所有个人资料都有可能被盗走，比如银行账户信息，信用卡密码等；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("DNS /DNS劫持：本协议中所述DNS是指网络定义的一种协议,为域名和IP地址相互映射，能够使商户更方便地访问互联网,DNS劫持是指恶意攻击者通过中间人攻击篡改域名和IP的对应关系,从而导致商户访问一些虚假的网站；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("热点劫持：本协议中所述热点劫持是指恶意攻击者通过恶意攻击劫持原有WiFi热点，从而捕捉通过热点中的所有商户个人信息及其他信息；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("账户资金：商户在银行账户内的资产，及商户在合法运营的第三方支付机构所设本商户实名账户中的资产；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("直接损失：因符合理赔范围的情形而被盗取的账户资金。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("三、索赔条件及理赔范围")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("商户应同时具备以下（一）至（五）款列明的各项条件，方可根据本公司商户安全理赔规则申请索赔:")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（一）索赔的前提条件")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.商户赖以执行参保的设备持有者必须是WiFi万能钥匙的手机注册用户，且其安装并使用的WiFi万能钥匙手机客户端中必须已发布施行了本保险计划（即该用户必须安装WiFi万能钥匙安卓版4.0或者iOS版3.3.5以上版本及此后发布的更新版本）。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.商户因分享热点，被恶意利用，发生本协议所列明的劫持攻击，导致勒索病毒造成资金损失的情形。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.因商户分享热点导致账户资金被盗，并发生本协议第三条第（二）款中的情形而遭受了直接损失，应首次发生于本商户安全保险计划生效日之后。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.商户同意，在通过WiFi万能钥匙参保时向本公司提供其真实有效信息，且上述信息应与商户提交的索赔申请材料中的信息一致，即与本公司订立本协议的商户与实际因分享热点遭受损失并前来申请索赔的商户必须为同一商户。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.商户分享的热点属于有钥匙热点，商户必须是热点主人。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.商户按照本条第（五）款索赔流程的规定向公安机关报案并向保险公司提交了符合索赔要求的材料。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("7.商户因分享热点导致其银行账户资金和有资质的第三方支付软件中的资金遭受损失的事件必须发生在中华人民共和国大陆地区（不包括香港、澳门和台湾地区）。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（二）属于理赔范围的情形")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.商户欲前往特定合法网络购物网站、网络银行网站或第三方支付网站（以上简称“合法网站”）进行销售、购物、转账等操作时，商户在支付交易过程中DNS被钓鱼热点进行了信息篡改，从而导致商户账户资金被盗的；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.商户欲前往合法网站进行销售、购物、转账等操作时，钓鱼热点已对该网站进行了DNS劫持，从而使商户连接上了一个钓鱼网站，导致了商户账户资金被盗的；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.商户在合法网站正常操作销售、购物、转账等操作的过程中，钓鱼热点非法获取了商户录入及传递的交易信息，导致商户信息泄露继而造成账户资金被盗；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.商户欲下载特定应用软件，商户连接的热点被劫持后，商户实际下载了仿冒恶意软件，且一般商户无法判断该软件的真伪。商户在仿冒恶意软件中录入交易信息，或仿冒软件将劫持的商户短信等个人信息发送至恶意第三方，从而导致商户账户资金遭受损失。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.商户连接该热点并用于执行销售、购物、转账等操作的电子设备，被劫持（DNS、ARP）攻击，植入勒索病毒，导致生产中断或者其他直接损失。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（三）不属于理赔范围的情形")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("商户因以下情形产生的经济损失或其他损失，不属于理赔范围，无权向本公司或保险公司申请索赔：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("1.商户不具备本协议第三条第（一）款中列明的索赔全部前提条件；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("2.商户不能根据本保险计划规定提供证据及/或其他索赔材料的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("3.商户未依据本协议第三条第（五）款中的规定进行报案和/或进行证据保全的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("4.自直接经济损失发生之日起15个自然日内，商户未依据本协议第三条第（五）款中的规定向保险公司提交索赔材料的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("5.商户使用WiFi万能钥匙分享热点的行为与商户遭受的财产损失不具有直接因果关系；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("6.商户主动接受虚假诈骗广告信息植入在其所分享的特定热点中，用户连接该热点后，轻信了该虚假广告信息而遭受了财产损失，商户就该损失进行了赔偿的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("7.在商户使用WiFi万能钥匙分享热点后，因商户故意或重大过失导致下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）商户主动向他人账号划转资金或主动为他人发送的代付链接付款的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）商户主动泄露WiFi密码、网上银行账号、密码、支付短信的交易验证码或其他可能导致财产损失的信息，或主动允许他人远程协助的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）WiFi密码、网上银行账号、密码已被他人知悉，或丢失了数字证书载体后，商户未立即变更账号、密码或通知银行冻结网上银行账户的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（4）商户对其WiFi网络信息，收银系统以及账户资金安全管理不善，因其雇员或管理执行人篡改WiFi密码、劫持盗用收银系统，盗取账户资金而导致损失的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（5）其他因商户故意或重大过失导致的财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("8. 商户在网上交易过程中，因买家违背诚信经营原则导致下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）与买家因交易纠纷造成的损失，包括但不限于电子商务买家账号被盗等引起的一切财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）由于买家不诚信问题造成的损失，包括但不限于迟延付款、拒绝付款等引发消费纠纷而引起的一切财产损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）虽经网页链接跳转，但商户系在正规网站进行正常交易行为时，由于买家违背诚信经营原则而遭受的财产损失。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("9.商户网购过程中，因其所购买标的物之特殊性导致的下列情形的财产损失：")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（1）商户在网络游戏私服中进行的交易或充值行为；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（2）以虚拟物品为交易对象的，包括但不限于虚拟财产（如虚拟游戏装备、虚拟货币、虚拟道具等）、游戏人物、游戏辅助物品的，或用户在网络游戏中直接交换物品的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（3）商户购买药品、保健品的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（4）涉及盗版及仿制品、走私、非法销售物品的交易；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（5）涉及网络赌博、博彩类交易（包括但不限于“赌球”、“21点”、“押大小”、“购买彩票”等）；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("（6）其他涉嫌购买国家法律禁止销售或者交易的物品的任何交易。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("10.网站经营者或任何第三方已赔偿或补偿了商户经济损失，或商户经WiFi万能钥匙协助已挽回经济损失，或商户已通过WiFi万能钥匙的其他理赔/保障计划获得赔偿的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("11.财产损失超出本协议第三条第（四）款中索赔限额的部分；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("12.商户故意骗保，或在未发生理赔情形或未遭受任何财产损失的前提下谎称发生了理赔情形或伪造损失证据的，或商户因从事非法行为而遭受的任何损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("13.商户有损害本公司商誉、扰乱本公司正常经营秩序言行的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("14.针对同一索赔事件，保险公司向商户进行理赔后，商户又追加索赔申请的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("15.WiFi万能钥匙或保险公司工作人员依照本协议的约定联系商户时，自首次尝试联系商户起72小时内仍无法与商户取得联系的，或商户不履行本协议约定的配合义务的；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("16.商户遭受的直接经济损失以外的一切间接损失、预期利益、精神损害或其他损失；")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("17.其他根据WiFi万能钥匙商户安全保险计划不属于理赔范围的情形。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（四）索赔限额")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('table', {
    attrs: {
      "width": "100%",
      "border": "1",
      "cellpadding": "0",
      "cellspacing": "0"
    }
  }, [_c('tr', [_c('td', [_vm._v("保险责任")]), _vm._v(" "), _c('td', [_vm._v("每一商户单日/单次索赔限额")]), _vm._v(" "), _c('td', [_vm._v("每一商户累计索赔限额")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("WiFi万能钥匙在提供服务的过程中造成了商户损失")]), _vm._v(" "), _c('td', [_vm._v("人民币贰万元整")]), _vm._v(" "), _c('td', [_vm._v("人民币壹拾万元整")])])])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("单次事故赔偿限额：人民币壹拾万元整")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("（单次事故：指因同一或基本相同的风险原因导致的一系列索赔事件（即群体性事件），视为一起事故，前述风险原因的认定以本公司技术部门的判定结果作为标准）")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("（五）索赔流程")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.证据保全：商户在使用WiFi万能钥匙分享热点后，发现账户资金遭受损失的，应立即采取相关证据保全措施，不应自行刷机、清理交易设备缓存、删除WiFi万能钥匙客户端、历史短信或历史访问网址记录，或自行删除交易过程中与交易对方的聊天记录及所下载的软件，以免导致相关证据无法保全；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.报案：商户在使用WiFi万能钥匙分享热点后，发现账户资金遭受损失的，应立即拨打保险公司电话进行报案，并应于10个自然日内前往具有管辖权的公安机关进行报案，并取得案件受理通知书等相关证明材料；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.准备索赔资料：商户应自账户资金遭受经济损失之日起15个自然日内根据WiFi万能钥匙客户端索赔界面的提示准备索赔资料，并听从工作人员的操作指导，积极配合工作人员的工作，并配合提供相关损失证明文件，以便有效追查被盗情况并保全证据；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.提交索赔资料：商户应根据保险公司工作人员的指示提交索赔资料，并确保其所提交的资料的真实性，否则，本公司及保险公司有权拒绝受理或赔付商户的索赔申请；商户知悉并了解，该等资料中的相关信息包括但不限于商户身份证号码、银行卡号、手机号码、详细住址等个人信息，商户在此同意并授权本公司及保险公司为实现本协议项下的索赔目的对商户的该等个人信息予以采集和使用；")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("商户应通过线下快递方式递交如下索赔资料：")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("营业执照彩色复印件")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("法定代表人身份证复印件")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("授权委托书和代理人身份证复印件（商户办理理赔事务的代理人非为营业执照所载的法定代表人时需要提供）")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("向公安机关报案的相关证明（报案或立案证明）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("非商户授权交易补偿申请表")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("索赔人被盗账户信息截屏")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("被盗账户对账单截屏（须标记盗刷交易明细信息：交易日期、付款人信息、交易币种、交易金额、入账币种、入账金额）")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_c('b', [_vm._v("被盗账户挂失证明（信息截屏，包含挂失日期等）")])]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_vm._v("索赔人出险期间手机设备在公安机关的备案数据")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("被盗账户近半年交易数据（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("涉及诉讼、仲裁的，递交相关司法文书、对方提交的证据副本等（如有）")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("其他本公司或保险公司认为对向商户提供理赔服务所必须的材料。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.理赔结果：保险公司根据商户提交的材料将认定最终理赔结果，如最终确认属于理赔责任范围内的情形，由保险公司向商户指定的个人收款账户支付赔款，最终理赔额在人民币3000元（含3000元）以下的案件由保险公司在确认最终理赔结果后的5个工作日之内支付赔款；最终理赔额在人民币3000元以上的案件由保险公司在确认最终理赔结果后的10个工作日之内支付赔款。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("四、商户的权利与义务")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.商户使用WiFi万能钥匙分享热点后商户账户资金遭受直接经济损失的，商户有权向保险公司提起索赔申请，经本公司及保险公司认定情况属实并符合索赔条件及范围的，保险公司将依据理赔规则给予商户理赔。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.商户向保险公司提起索赔申请，应按照本公司商户安全理赔规则提交所有相关索赔材料。商户保证，其所提交的一切索赔材料、所作出的任何陈述或保证均真实准确且合法有效，并应独立承担因违反上述保证所引发的一切法律责任。商户未充分履行上述义务或违反上述保证的，本公司及保险公司有权不予理赔；保险公司已经向该商户支付理赔金的，有权向该商户追回，并要求商户赔偿本公司及保险公司因此遭受的一切损失。同时，本公司及保险公司将向有关机关报案，追究该商户骗保的刑事责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.商户应保证其热点分享及支持用户连接网络的行为不触犯任何法律、行政法规、相关政策且不侵犯任何第三人的合法权益。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.商户应向保险公司提供真实有效的收款账户信息，因商户原因导致提供的收款信息错误而无法收到理赔额的情况，本公司及保险公司不承担任何责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.商户向保险公司或本公司发起索赔申请，即表明商户已同意严格遵守本公司发布的针对WiFi万能钥匙安全保险计划的所有规则，并同意以最新的规则作为认定最终理赔结果的依据。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.商户承诺：未经本公司书面许可，不得将最终理赔结果向任何第三方披露。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("五、本公司的权利与义务")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("1.商户知悉并完全同意本公司有权随时修改、更新、暂停或永久终止保险计划，无需因此对商户承担法律责任。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.本公司有权依据理赔规则对商户向保险公司的索赔申请进行审核以确定是否向其提供理赔服务，本公司有完全的权利同意或拒绝商户的申请。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("3.本公司对本协议项下的理赔义务承担有限责任，在任何情形下，商户同意保险公司向其支付的理赔金的最高上限依照本协议第（四）条之规定执行。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.如WiFi万能钥匙及保险公司在审查商户所提交的索赔申请时发现重大刑事案件线索的，本公司及保险公司有权在通知商户后以商户索赔资料为基础向警方提供案件侦查线索或向相关司法机关检举。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.商户因使用WiFi万能钥匙所遭受的经济损失，通过第三方获得赔付或司法程序或其他合法程序得以追缴或退赔的，若保险公司已根据本保险计划向商户进行赔付的，则有权在其对商户的赔付范围内要求商户进行返还。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("6.本公司承诺：未经商户允许，除为实现本协议项下的理赔目的及法律法规隐私保护政策另有规定的情形外，不对外披露或向第三方提供商户的任何信息。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold"
  }, [_vm._v("六、其他")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti"
  }, [_c('b', [_vm._v("1.本公司郑重提醒商户注意本协议中免除或限制责任的条款，请商户仔细阅读，自主考虑风险。")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2.本协议所定的任何条款的部分或全部无效者，不影响其它条款的效力。")]), _vm._v(" "), _c('p', {
    staticClass: "title_bold ti",
    staticStyle: {
      "color": "red"
    }
  }, [_vm._v("3."), _c('b', [_vm._v("本协议的解释、效力及纠纷的解决，适用于中华人民共和国法律。若商户和本公司之间发生任何纠纷或争议，首先应友好协商解决，协商不成的，商户在此完全同意双方将纠纷或争议提交本公司所在地人民法院通过诉讼方式解决。")])]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("4.本WiFi万能钥匙商户安全保险计划自2020年9月16日起生效施行。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("5.若您对本协议及本保险计划有任何意见，欢迎垂询本公司客服中心400-035-8000。")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("南京尚网网络科技有限公司")]), _vm._v(" "), _c('p', {
    staticClass: "text ti"
  }, [_vm._v("2020年9月16日")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7dc405e3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/protocolIos.vue
// module id = 837
// module chunks = 1